import UserError from './UserError.js'

export class NotFoundUserError extends UserError {
  #message

  /**
   * @param {string} message
   * */
  static create({message}) {
    return new NotFoundUserError({message})
  }

  constructor({message}) {
    super()
    this.#message = message
  }

  get message() {
    return this.#message
  }

  toJSON() {
    return {message: this.#message}
  }
}
